import { createSlice } from '@reduxjs/toolkit';

export interface EligibilityChecksState {
  warningDismissed: boolean;
}

const initialState: EligibilityChecksState = {
  warningDismissed: false,
};

export const eligibilityChecksSlice = createSlice({
  name: 'eligibilityChecks',
  initialState,
  reducers: {
    dismissWarning: state => {
      state.warningDismissed = true;
    },
    resetWarning: state => {
      state.warningDismissed = false;
    },
  },
});

export const { dismissWarning, resetWarning } = eligibilityChecksSlice.actions;

export default eligibilityChecksSlice.reducer;

